import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { InspectionCheCkContaxt } from './InspectionCheckProvide';
import { useContext } from 'react';
import { TextBox } from '../../../../Core/FormInput';

export const InspectionBreakPerfomance = ({ classes }) => {
    const { state, handleInput } = useContext(InspectionCheCkContaxt);
    const isReadOnly = Boolean(state.isDisabled || state.vehicleInspectionInspectorSignature);

    return (
        <Grid item xs={12} sm={12} md={6} lg={6}>
            <div className={classes.sectionCard} style={{ height: '100%', display: 'flex', flexDirection: 'column', marginBottom: 0 }}>
                <div className={classes.sectionHeader}>
                    <div className={classes.sectionTitleWrap}>
                        <span className={classes.sectionAccent} />
                        <h3 className={classes.sectionTitleText}>Brake Performance</h3>
                    </div>
                </div>
                <TableContainer style={{ flex: 1 }}>
                    <Table aria-label="simple table" size="small">
                        <TableHead>
                            <TableRow style={{ background: '#f1f5f9' }}>
                                <TableCell width="20%" style={{ color: '#f50057', fontWeight: 700, fontSize: 11.5, textTransform: 'uppercase' }}>
                                    IM Reference
                                </TableCell>
                                <TableCell align="left" width="50%" style={{ color: '#f50057', fontWeight: 700, fontSize: 11.5, textTransform: 'uppercase' }}>
                                    Item Inspected
                                </TableCell>
                                <TableCell align="left" width="30%" style={{ color: '#f50057', fontWeight: 700, fontSize: 11.5, textTransform: 'uppercase' }}>
                                    Efficiency
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ fontSize: 12 }}>71</TableCell>
                                <TableCell style={{ fontSize: 12, fontWeight: 500 }}>Service Brake Performance</TableCell>
                                <TableCell>
                                    <TextBox
                                        placeholder="%"
                                        disabled={isReadOnly}
                                        name="vehicleInspectionServiceBrakePerformance"
                                        value={state.vehicleInspectionServiceBrakePerformance}
                                        onChange={handleInput}
                                        type="number"
                                        style={{ fontSize: 12 }}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow style={{ background: '#f8fafc' }}>
                                <TableCell style={{ fontSize: 12 }}>72</TableCell>
                                <TableCell style={{ fontSize: 12, fontWeight: 500 }}>Secondary Brake Performance</TableCell>
                                <TableCell>
                                    <TextBox
                                        placeholder="%"
                                        disabled={isReadOnly}
                                        name="vehicleInspectionSecondaryBrakePerformance"
                                        value={state.vehicleInspectionSecondaryBrakePerformance}
                                        onChange={handleInput}
                                        type="number"
                                        style={{ fontSize: 12 }}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ fontSize: 12 }}>73</TableCell>
                                <TableCell style={{ fontSize: 12, fontWeight: 500 }}>Parking Brake Performance</TableCell>
                                <TableCell>
                                    <TextBox
                                        placeholder="%"
                                        disabled={isReadOnly}
                                        name="vehicleInspectionParkingBrakePerformance"
                                        value={state.vehicleInspectionParkingBrakePerformance}
                                        onChange={handleInput}
                                        type="number"
                                        style={{ fontSize: 12 }}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </Grid>
    );
};

export default InspectionBreakPerfomance;
